import React from 'react'
import { View, Text } from 'react-native'
import { H2, H3, TextSmall, TextSmall0, commonStyle } from '../TextStyles/TextStyles'

export const cardInfos = {
  aurinko_kerrostaloihin_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Esimerkissä As Oy Haapalahdenkatu 11 kehittää toimintamallia, jossa
        taloyhtiö voi jakaa katolla olevasta aurinkosähköjärjestelmästä sähköä
        asuntoihin hyvityslaskentamallin avulla. Tällöin järjestelmät voitaisiin
        mitoittaa suuremmiksi, koska siitä suurempi osa saataisiin omaan
        käyttöön. Aurinkopaneelien tuottaman sähkön myynti verkkoon
        markkinahinnalla ei ole kannattavaa. As Oy Haapalahdenkatu 11:ssa
        tehtävässä kokeilussa tutkitaan aurinkosähköinvestointiin liittyvää
        päätöksentekoa, tarvittavia kirjauksia asunto-osakeyhtiön
        yhtiöjärjestykseen, aurinkosähköinvestoinnin kannattavuutta sekä
        asukkaiden tyytyväisyyttä.
      </TextSmall>
      <TextSmall>
        Tavoitteena on myös vaikuttaa lainsäädäntöön niin, että itse tuotetun
        aurinkosähkön hyvityslaskenta tulisi mahdolliseksi.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  aurinko_kerrostaloihin: (
    <View>
      <H2>Aurinkosähköä kerrostaloihin</H2>
      <TextSmall>
       Sähkölässä asennetaan 600 kerrostaloon aurinkopaneeleja. Oletetaan, että 85% kerrostaloista
        soveltuu aurinkosähkön tuotantoon.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Oletetaan, että aurinkopaneelit tuottavat vuodessa 10.125kWh sähköä.
        Päästövähennys kerrostaloa kohti on noin 1,6 t CO2. Kaikkia 600 kerrostaloa
        kohden päästövähennys on vajaa 1 kt CO2, joka on noin 0,65% Sähkölän
        päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Investointikustannukseksi oletetaan 18.000€/talo.</TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Jos kukin kerrostalo onnistuu käyttämään 80% tuottamastaan sähköstä itse,
        säästävät ne vuodessa sähkölaskussaan yli 1000€. Kahdenkymmen
        vuoden aikana säästöä kertyy noin 21.000€, eli investointikustannusten
        jälkeen noin 3500 €/kerrostalo. Sähkölässä säästetään yhteensä noin 2M€.
      </TextSmall0>
    </View>
  ),
  aurinko_pientaloihin_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Projektin tarkoituksena on näyttää käytännössä, että taloa ei tarvitse
        rakentaa ulkovaipaltaan matala- tai passiivienergiataloksi, jotta siitä
        saataisiin tehtyä nettonollaenergiatalo muilla järkevillä olemassa
        olevilla energiateknisillä ratkaisuilla. Hankkeen tavoitteena on ollut
        rakentaa hirsirakenteinen omakotitalo rinneratkaisuna, joka täyttää
        vuoden 2020 EU:n energiamääräykset.
      </TextSmall>
      <TextSmall>
        Projektissa on keskitytty energiaratkaisuihin, joita voidaan hyödyntää
        sekä uudis- että korjausrakentamisessa.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  aurinko_pientaloihin: (
    <View>
      <H2>Pientaloihin 45 m2 aurinkopaneeleita</H2>
      <TextSmall>
        Sähkölässä asennetaan 45m2 aurinkopaneeleja 3000 omakotitaloon tai 1300 rivitaloon.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Aurinkopaneelien tuotto on 4700 kWh. Pientaloa kohti päästövähennys
        on 743 kg vuodessa. 3000 pientaloa kohti päästövähennys on noin
        2,2 kt, eli noin 2% Sähkölän vuotuisista päästöistä ja 1300 pientaloa
        kohti vajaat 1 kt, eli noin 1% Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Järjestelmät hankitaan avaimet käteen–toimituksena, jonka hinta on arviolta 10.000€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Koska sähköä tuotetaan paljon yli oman tarpeen, mutta myydystä sähköstä ei
        saada kuin 5 snt/kWh, mittavasta investoinnista ei synny 20 vuodessakaan juuri
        kustannussäästöjä. Talon omistaja säästää itse
        käytetyn sähkön avulla 289€ vuodessa ja saa myydystä sähköstä 117€,
        mikä on yhtensä 406€ vuodessa.
      </TextSmall0>
    </View>
  ),
  biokaasua_biojatteesta_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Gasum rakentaa ja operoi biokaasulaitoksia tarjoten kunnille ja
        yrityksille biohajoavan jätteen käsittelypalveluita. Lisäksi Gasum
        tuottaa eloperäisistä raaka-aineista biokaasua ja lannoitukseen
        käytettäviä kierrätysravinteita ja mullan raaka-aineita. Myös useat
        pienemmät yhtiöt operoivat omia biokaasulaitoksiaan Suomessa. Suomen
        Biokierto ja Biokaasu ry:llä oli syksyllä jäsenenä 26 organisaatiota.
        Gasumilla on syksyllä 2019 Suomessa myös 33 kaasutankkausasemaa.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  biokaasua_biojatteesta: (
    <View>
      <H2>Biokaasulaitos biojätteille</H2>
      <TextSmall>
        Kaupungin biojätteiden käsittelyä varten rakennetaan
        biokaasulaitos, jonne toimitetaan aiemmin kompostoitavaksi viedyt
        jätteet. Laitoksessa käsitellään noin 6000 tonnia biojätteitä vuodessa.
        Laitos tuottaa sähköä ja lämpöä myyntiin. Toisella kortilla lisätään
        laitoksen kapasiteettia niin, että laitoksessa käsitellään myös
        naapurikunnan biojätteet (toiset 6000 tonnia).
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Biojätteiden käsittely biokaasuksi vähentää kasvihuonekaasupäästöjä arviolta 70 kg CO2-ekv tonnia kohti
        verrattuna kompostointiin. Päästövähennys syntyy, koska jätteiden
        hajoamisessa syntyvä metaani otetaan talteen ja käytetään energiaksi.
        Päästövähennykseksi voidaan laskea noin 0,7% Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Biokaasulaitoksen investointikustannukseksi arvioidaan noin 2M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Biokaasulaitoksen tuotot 20 vuodessa ovat arviolta yhteensä 4M€, eli investointikustannusten jälkeen jää
        tuotoiksi 2 M€. Suurin osa tuotoista tulee biojätteen
        vastaanottomaksuista.
      </TextSmall0>
    </View>
  ),
  hoivarakennus_nollaenergia_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Järvenpään Mestariasunnot -konserni rakennutti vuonna 2009-2011 yhden
        Suomen ensimmäisistä nollaenergiakerrostaloista. Siinä on 44 asuntoa
        huonokuntoisille ja muistihäiriöisille vanhuksille. Paikalla sijainnut
        huonokuntoinen rakennus purettiin kivijalkaan. Energiatehokkuudesta
        vastaavat mm. maalämpö- ja viilennys, aurinkopaneelit, hissienergian
        talteenotto yhdistettynä tiiviiseen ja korkeiden normien mukaisesti
        rakennettuun kiinteistöön. Rakennuksen lämmitys toteutetaan
        lämpökaivoilla, joita hyödynnetään kesällä asuntojen viilennykseen.
        Ylimääräinen lämpö luovutetaan Mestariasuntojen omistamalle
        naapurikiinteistölle.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  hoivarakennus_nollaenergia: (
    <View>
      <H2>Hoivakodit nollaenergiataloiksi</H2>
      <TextSmall>
        Kaikki Sähkölän hoitoalan rakennukset (65 kpl) uusitaan nollaenergiataloiksi.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Vanhojen rakennusten oletetaan kuluttavan kaukolämpöä 186kWh/m2 ja sähköä 89kWh/m2. Rakennusta kohti päästövähennys on 35t
        CO2 ja 65 rakennusta kohti noin 2,2 kt CO2, joka vastaa noin 1,5% Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Rakennusten uusimisen arvioidaan maksavan noin 78 M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Säästöt rakennusten energiakuluissa tuottavat 20 vuodessa noin 22 M€. Säästöt eivät riitä kattamaan investointeja, vaan
        investoinnit on perusteltava muilla tekijöillä: esim. rakennusten elinkaarella, laatutekijöillä tai muuttuneilla palvelutarpeilla.
      </TextSmall0>
      <TextSmall>
       Nollaenergiatalo ei ole paljoakaan vastaavaa tavallista rakennusta kalliimpi, mutta säästöt energiankulutuksessa 20 vuoden ajalta
        ovat jo mittavia.
      </TextSmall>
    </View>
  ),
  kaukolammon_ohjaus_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Hankkeessa kehitetään kerrostaloille älykästä ratkaisua, jossa
        kerrostaloihin varataan lämpöä edullisena aikana ja hyödynnetään se
        lämmön huippukulutuksen aikaan. Ratkaisu perustuu kerrostaloon
        asennettavaan Leanheat-ohjausjärjestelmään sekä asuntokohtaisiin
        lämpötilamittareihin. Ohjausjärjestelmä oppii kunkin talon lämmöntarpeen
        ja optimoi lämmityksen muun muassa sääennusteen ja kaukolämmön
        tuntiperusteisen hinnan avulla. Ratkaisua on testattu syksystä 2015
        alkaen noin 40 asuinkerrostalossa, joissa on yhteensä 2000 asuntoa.
        Tavoitteena on saavuttaa 10–20 prosentin säästö lämmönkulutukseen.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  kaukolammon_ohjaus: (
    <View>
      <H2>Kaukolämmön älykäs ohjaus</H2>
      <TextSmall>
       Toteutetaan kaukolämmön älykäs ohjaus 325 kaukolämmön
        piirissä olevaan kiinteistöön (asuinkerrostaloja, julkisia ja
        liikerakennuksia, poislukien opetusrakennukset ja hoitoalan rakennukset,
        joihin tehdään muita toimenpiteitä).
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
       Älykkäällä ohjauksella voidaan vähentää
        lämmönkulutusta arviolta noin 10%. Tämän oletetaan vähentävän Sähkölän
        kaukolämmön päästöjä 10%, eli 2,43 kt CO2, eli noin 1,6% Sähkölän
        päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Kaukolämmön älykkääseen ohjaukseen tarkoitetut laitteet maksavat noin 4.500-9.000€/kiinteistö ja niiden
        takaisinmaksuaika on 2-4 vuotta. Investointikustannukseksi arvioidaan
        Sähkölässä 9.000€/kiinteistö. Sähkölässä tällaisia rakennuksia on 650,
       eli kokonaisinvestoinniksi tulee noin 5,8M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Vuodessa kukin rakennus säästää kaukolämpölaskussa melkein 2.000€.
        Kahdenkymmenen vuoden aikana ovat Sähkölän säästöt kaukolämpölaskussa
        alkuinvestoinnilla vähennettynä lähes 19M€.
      </TextSmall0>
    </View>
  ),
  kaukolampo_datakeskuksesta_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Yandex on rakentanut palvelinkeskuksen, jossa yhteistyössä Nivoksen
        kanssa hukkalämmöstä tuotetaan kaukolämpöä Mäntsälän kotitalouksiin ja
        teollisuuden tarpeisiin. Kaukolämmön tuotanto Yandexin datakeskuksen
        hukkalämmöstä muodostaa noin 65 % pienemmän elinkaaren hiilijalanjäljen
        verrattuna vastaavan määrän tuottamiseen maakaasun avulla. Maakaasun
        tarve on lämmön kierrättämisen myötä laskenut 70%.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  kaukolampo_datakeskuksesta: (
    <View>
      <H2>Kaukolämpö datakeskuksesta</H2>
      <TextSmall>
        Kortin avulla rakennetaan Sähkölässä sijaitsevaan datakeskukseen
        hukkalämmön talteenottolaitteisto.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Laitos vastaa noin 16% Sähkölän kaukolämmön kulutuksesta. Sähkölän
        kaukolämmön tuotannon päästöt pienenevät noin 3,8 kt, kun taas
        laitteiston lämpöpumpun sähkönkulutus lisää päästöjä noin 1,6 kt CO2.
        Nettopäästövähennys Sähkölässä on noin 2,2 kt CO2, joka vastaa noin 1,5%
        Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Investoinnin oletetaan Sähkölässä olevan noin 4,5 M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Kaukolämmön tuotantokustannusten voidaan olettaa laskevan noin 10%. Näin saadaan kokonaissäästöksi
        Sähkölässa 20 vuoden ajalta 0,7 M€.
      </TextSmall0>
    </View>
  ),
  maalampo_aurinko_kouluihin_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Sakarinmäen pilottihankkeessa Helen testaa uusia energiaratkaisuja.
        Koulukeskukseen on rakennettu uusiutuvan energian lämmitysratkaisu, joka
        muodostuu aurinkokeräinten, maalämpöjärjestelmän ja lämpövarastojen
        kokonaisuudesta. Lämmitysjärjestelmää suunniteltaessa asetettiin
        tavoitteeksi 80% uusiutuvan energian osuus aurinko- ja maalämmöllä. Tämä
        tavoite saavutettiin ensimmäisenä käyttövuonna 2015: maalämmön osuus oli
        79% ja aurinkolämmön osuus 3%.
      </TextSmall>
      <TextSmall>
        Sakarinmäen koululaiset ovat alusta asti olleet mukana koulun
        lämmitysmuodon uudistuksessa: Energia-asiat integroidaan koulun
        opetukseen käytännönläheisesti.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  maalampo_aurinko_kouluihin: (
    <View>
      <H2>Maalämpö ja aurinkokeräimet kouluihin</H2>
      <TextSmall>
        Asennetaan maalämpö-aurinkokeräinjärjestelmä Sähkölän
        kaikkiin 27 kouluun. Päästövähennys rakennusta kohden on 52t CO2
        ja se tulee pääosin maalämpöjärjestelmistä. Kaikkien koulujen osalta
        päästövähennys on 1,4 kt CO2, joka vastaa noin 1% Sähkölän päästöistä.
      </TextSmall>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Investoinnit koulua tai päiväkotia kohti ovat yhteensä keskimäärin noin
        414.000€. Kaikkien Sähkölän 27 koulun osalta investoinniksi tulee noin
        11,2M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Säästöt koulua kohti ovat lähes 24.000€ vuodessa. Sähkölän
        27 koulussa säästetään lämmityskuluissa 20 vuoden aikana 12,8 M€, eli
        investointikustannusten jälkeen kaupunki on säästänyt noin 1,6 M€.
      </TextSmall0>
    </View>
  ),
  maalampo_pientaloihin_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Projektin tarkoituksena on näyttää käytännössä, että taloa ei tarvitse
        rakentaa ulkovaipaltaan matala- tai passiivienergiataloksi, jotta siitä
        saataisiin tehtyä nettonollaenergiatalo muilla järkevillä olemassa
        olevilla energiateknisillä ratkaisuilla. Hankkeen tavoitteena on ollut
        rakentaa hirsirakenteinen omakotitalo rinneratkaisuna, joka täyttää
        vuoden 2020 EU:n energiamääräykset.
      </TextSmall>
      <TextSmall>
        Projektissa on keskitytty energiaratkaisuihin, joita voidaan hyödyntää
        sekä uudis- että korjausrakentamisessa.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  maalampo_pientaloihin: (
    <View>
      <H2>Maalämpöä pientaloihin</H2>
      <TextSmall>
        Asennetaan Sähköläläisten asuntoihin maalämpöjärjestelmä; joko 1500 omakotitaloon tai 700 rivitaloasuntoon.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Maalämpöjärjestelmän lasketaan säästävän lämmitysenergiaa vuodessa noin
        9.000 kWh/pientalo. 1500 talon osalta päästövähennys on 2,6 kt, eli noin 2% Sähkölän päästöistä
        ja 700 pientalon osalta 1,2 kt ja noin 1% Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Investointikustannukseksi oletetaan noin 18.500€/talo. </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Maalämpöjärjestelmän on arvioitu säästävän vähintäänkin 1000€ vuodessa. Kahdenkymmenen vuoden aikana säästöjä on kertynyt vähintäänkin
        20.000€ pientaloa kohti. Kun investointikustannukset vähennetään, jää
        säästöjä pientaloa kohti ainakin 1.500€. Jos kaikki 3.700 investointia
        toteutetaan, Sähkölässä säästetään yhteensä noin 5,5M€.
      </TextSmall0>
    </View>
  ),
  metaani_talteenotto_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Tästä ei ole esimerkkiä energiakokeilut.fi –tietopankissa, mutta tämä on
        laskettu mukaan, koska tilastojen mukaan suurin osa Sähkölän tapaisen
        kunnan jätehuollon kasvihuonekaasupäästöistä tulee vanhoilta, jo
        suljetuilta kaatopaikoilta. Sähkölässä suljeltuilta kaatopaikoilta
        syntyy lähes 70% kaikista jätehuollon kasvihuonekaasupäästöistä.
      </TextSmall>
      <TextSmall>
        Kortti on siis lisätty peliin pääasiassa pelin vaatimusten takia.
      </TextSmall>
    </View>
  ),
  metaani_talteenotto: (
    <View>
      <H2>Metaanin vähentäminen suljetuilta kaatopaikoilta</H2>
      <TextSmall>
       Suljetuilta kaatopaikoilta ei tähän asti ole otettu talteen kaatopaikkakaasuja ja niiden päästöt ovat 15 kt CO2-ekv
        vuodessa.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Pienille suljetuille kaatopaikoille edullisena ratkaisuna pidetään
        hapettamiskerrosta. Tehokkaalla hapettamiskerroksen käytöllä voitaisiin
        vähentää metaanipäästöt noin puoleen. Tällöin päästövähennys olisi noin
        7,5 kt CO2-ekv vuodessa eli noin 5% Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Hapettamiskerroksen kustannuksiksi arvioidaan noin 20€/t CO2-ekv4.
      </TextSmall0>
      <TextSmall>Sähkölässä kustannukset olisivat noin 150.000€.</TextSmall>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Toimenpiteestä ei saa kustannussäästöjä.
      </TextSmall0>
    </View>
  ),
  paastotonta_sahkoa_kysyntajousto_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Ahvenanmaalla on käynnissä laaja hanke, jossa testataan joustavaa ja
        älykästä energiajärjestelmää. Koko maakunnan tarvitsema energia on
        tarkoitus tuottaa omavaraisesti uusiutuvilla luonnonvaroilla vuoteen
        2025 mennessä. Uudeksi perusvoimaksi kaavaillaan tuulivoimaa, jota
        täydennetään aurinko- ja bioenergialla. Tuulivoiman osuus voisi kasvaa
        jopa kymmenkertaisesti. Haasteena on sääolosuhteiden ja vuodenaikojen
        vaihtelun aiheuttamien tuotanto- ja kulutushuippujen tasaaminen.
        Ongelmaan haetaan ratkaisua energian varastoinnin, kysyntäjouston sekä
        energian käytön tehostamisen ja vähentämisen kautta.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  paastotonta_sahkoa_kysyntajousto: (
    <View>
      <H2>Kysyntäjousto</H2>
      <TextSmall>
        Puoleen kaikista Sähkölän rakennuksista asennetaan sähkön kulutusta ohjaava laitteisto. Laitteisto ohjaa kulutusta ja sähkölämmitystä siten,
        että kulutusta vähennetään, kun sähkö on kallista ja sitä lisätään, kun
        sähkö on halpaa.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Pelissä oletetaan, että yhdessä muiden toimenpiteiden kanssa kaupungin
        käyttämä sähkö saadaan päästöttömäksi. Päästövähennys tietysti riippuu
        myös muista toimenpiteistä sekä päästöttömän sähkön saatavuudesta (mm.
        vesi- ja tuulivoima). Jos Sähkölän kaikki sähköntarve saadaan tuotettua
        päästöttömästi, päästövähennys on noin 15 kt CO2, joka vastaa noin 5%
        Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Energiayhtiöiden oletetaan tekevät muut investoinnit. Jos laitteistot
        asennetaan kaikkiin Sähkölän rakennuksiin, saadaan
        kokonaisinvestoinniksi noin 7M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Suorat kustannussäästöt koituvat sähköyhtiöille, jotka maksoivat
        päästöoikeuden hinnasta elokuussa 2019 noin 28€/t CO2 EU:n
        päästökaupassa. Tällä päästöoikeuden hinnalla sähköyhtiöt säästäisivät
        vähän yli 4M€, joka ei kata investointikustannuksia.
      </TextSmall0>
      <Text style={[commonStyle.displayTextSmall, { opacity: 0 }]}>
        Muita, vaikeammin laskettavia kustannussäästöjä voi kuitenkin syntyä
        monelle taholle. Verkkoyhtiöt säästävät, jos sähkön kysynnän huippuja
        voidaan tasoittaa. Sähkön käyttäjät säästävät, jos voivat käyttää
        halvempaa sähköä. Sähkön tuottajat säästävät siinä, että kysyntähuippuja
        varten ei tarvitse ylläpitää varavoimalaitoksia.
      </Text>
    </View>
  ),
  robottibusseja_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        SOHJOA-hankkeessa ajettiin robottibusseilla neljällä eri reitillä kesän
        2016 ja loppuvuoden 2017 välillä noin kuukauden mittaisina
        kokeilujaksoina. Lisäksi robottibussit ovat olleet käytössä lyhyillä
        reiteillä erilaisissa tapahtumissa. Kokeilut alkoivat Helsingin
        Hernesaaressa heinä-elokuussa 2016, mistä siirryttiin Espoon Otaniemeen
        lokakuussa ja Tampereen Hervantaan marraskuussa. Vuonna 2017 Hervannassa
        jatkettiin samalla reitillä touko-kesäkuussa, mutta kesäksi suunniteltu
        kokeilu Helsingissä siirtyi seuraavaan vuoteen. Syksyllä 2017 ajettiin
        Helsinki-Vantaan lentokentällä lokakuussa ja Otaniemessä
        loka-marraskuussa. SOHJOA-hankkeessa käytetyt robottibussit ovat korkean
        automaation tason 4 pikkubusseja. Robottibussin liikkuminen perustuu
        ennalta ohjelmoituun reittiin ja reaaliaikaiseen, tarkkaan paikannukseen
        eri teknologioilla.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  robottibusseja: (
    <View>
      <H2>Robottibussit</H2>
      <TextSmall>
    Sähkölään hankitaan 10 robottibussia, jotka kulkevat jatkuvasti asuinalueiden ja juna-aseman välillä. Robottibussien avulla
        korvataan 140 päivittäistä Sähkölän sisäistä henkilöautolla tehtävää
        matkaa, eli 3,5% henkilöautolla tehtävistä matkoista.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Sähköisen robottibussiliikenteen on laskettu vähentävän päästöjä
        henkilöautoliikenteeseen nähden noin 95%. Tämä on noin 5% henkilöauton
        89 g CO2 päästöistä/henkilökilometri, eli päästöt pienenevät näiden
        matkojen osalta 95%. Olettaen, että Sähkölässä 10% kaupungin sisäisistä
        matkoista siirtyy robottibusseilla tehtäväksi, tämä vähentää Sähkölän
        henkilöautoliikenteen päästöjä 2,8 kt CO2 eli noin 2% Sähkölän
        päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Yhden robottibussin hinnaksi on arvioitu 350.000€. Kymmenen bussin
        hankinta maksaa siis 3,5 M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Kymmenellä bussilla oletetaan suoritettavan päivittäin 400 Sähkölän
        sisäistä matkaa. Jos korvattavat matkat ovat keskipituudeltaan 7 km, 10
        robottibussia säästää niihin siirtyviltä matkustajilta vuosittain n. 46.000€ polttoainekuluissa. Kymmenessä vuodessa säästöt ovat noin 0,46 M€,
        eli ne eivät kata robottibussien hankintamenoja. Muita hyötyjä ovat
        kuitenkin ilmanlaadun paraneminen asuinalueilla ja ruuhkien väheneminen.
      </TextSmall0>
    </View>
  ),
  sahkoautoja_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Työ- ja elinkeinoministeriö myönsi vuosina 2011-2015 yritysten
        sähköauto- ja latauslaitehankintoihin energiainvestointitukea, jonka
        tarkoituksena oli vauhdittaa sähköistä liikennettä Suomessa. Yritysten
        täytyi hankkia sähköautot vähintään 36 kk kestävällä
        leasing-sopimuksella. Latausjärjestelmien hankintaan yritykset saivat
        energiainvestointitukea, jos ne asensivat latausjärjestelmän yrityksen
        toimipisteeseen joko omaa käyttöä varten tai julkiseksi latauspaikaksi.
        Tukea saaneisiin autoihin tuli asentaa erillinen mittalaitteisto, joka
        mahdollisti tietojen keräämisen Tekesin EVE-ohjelman tutkimuksiin.
        Käyttöön otetut energiatukea saaneet latauspisteet kirjattiin
        valtakunnalliseen latauspistetietokantaan. Energiainvestointituen
        myöntäminen alkoi vuonna 2011, ja tukisitoumukset ovat voimassa vuoden
        2017 loppuun.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  sahkoautoja: (
    <View>
      <H2>Sähköautot</H2>
      <TextSmall>
        Korvataan tulevan kymmenen vuoden aikana hankittavista uusista autoista joko 1600 kpl tai 2400 kpl sähköautoilla.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Uusi sähköauto vähentää päästöjä 114 g/km CO2 verrattuna uuteen polttomoottoriautoon. Autoa kohti päästövähennys vuodessa on 1,6
        t CO2. 1600 uutta sähköautoa polttomoottoriautojen sijasta tuottaa
        päästövähennysstä noin 2,6 kt CO2, eli noin 2% Sähkölän päästöistä. 2400
        sähköautoa tuottaa noin 3,8 kt CO2 vähennyksen, eli noin 3% Sähkölän
        päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Keskimääräinen 4000 auton investointikustannus on noin 13 M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Sähköauton käyttäjä säästää 10 vuodessa keskimäärin 2500€
        polttoainekuluissa. Kaikki 4000 sähköauton omistajaa säästävät 10
        vuoden aikana yhteensä noin 10M€, joka jää alle autojen
        hankintakustannusten.
      </TextSmall0>
    </View>
  ),
  sahkobussit_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        Turun kaupungin joukkoliikenteessä aloitti kuusi sähköbussia
        liikennöinnin yhdellä bussilinjalla syksyllä 2016. Bussien toimittajaksi
        valittiin suomalainen Linkker Oy. Turku Energia rakentaa sähköbussien
        latausasemat. Sopimus sisältää bussien ja latauslaitteiden
        huoltosopimuksen seitsemän vuoden ajalle. Sähköbussien hankintaan
        kannustivat sähköisen liikenteen ympäristöhyödyt (meluttomuus,
        päästöttömyys), matkustamisen miellyttävyys sekä edullisuus pitkällä
        aikavälillä. Korkeamman hankintahinnan (dieselbusseihin verrattuna)
        katsotaan korvautuvan pienempinä käyttökustannuksina seitsemän vuoden
        sopimuksen aikana.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  sahkobussit: (
    <View>
      <H2>Sähköbussit</H2>
      <TextSmall>
        Korvataan Sähkölän 29 dieselbussia sähköbusseilla.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Yhden dieselbussin korvaaminen sähköbussilla vähentää päästöjä noin 37,5t CO2. Korvattaessa 29 dieselbussia
        sähköbusseilla pienennetään päästöjä n. 1,1 kt CO2. Tämä vastaa noin 0,7% Sähkölän kasvihuonekaasupäästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Sähköbussi maksaa noin 500.000€. Kymmenen vuodan aikana hankittavista busseista 70% oletetaan korvaavan poistuvaa
        kalustoa, ja näiden osalta kustannukseksi lasketaan sähköbussin ja dieselbussin hankintahinnan (250.000/kpl) erotus. Lisäksi hankitaan 5
        latauspistettä, hinta 250.000€/kpl. Näin bussien hankintakustannukseksi saadaan noin 9M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Liikenneviraston selvityksen mukaan sähköbussien käyttökustannukset ovat
        34 snt/km, kun dieselbussin ovat 60 snt/km. Jos kukin bussi ajaa
        vuodessa noin 100.000 km, kustannussäästöt 15 vuodessa (joka on bussin
        arvioitu käyttöikä) ovat noin 11M€, jolloin investointikustannuksen
        jälkeen jää säästöön noin 2M€.
      </TextSmall0>
    </View>
  ),
  yhteiskayttoautoja_esim: (
    <View>
      <H2>ESIMERKKI</H2>
      <TextSmall>
        EkoRent Oy toi markkinoille uudenlaisen autonvuokrauspalvelun, jossa
        kaikki vuokrattavat autot ovat täyssähköautoja. Palvelun käytöstä
        veloitetaan tuntipohjaisesti, ja veloitus koskee vain auton todellista
        käyttöaikaa. Autonvuokrauspalvelu lanseerattiin vuoden 2014
        loppupuolella. Palvelupisteet ovat sijainneet Helsingissä, Espoossa,
        Vantaalla ja Jyväskylässä. Toiminnan laajentamiseksi yritys haki vuonna
        2016 uutta pääomaa joukkorahoituksella, johon osallistuneet saivat
        vastineeksi sijoituksestaan osakkeita ja sähköauton ajoaikaa. Syksyllä
        2019 Ekorent kertoi lopettavansa sähköautojen vuokraustoiminnan Suomessa
        ja keskittyvänsä jatkossa sähkötaksipalveluun Afrikassa.
      </TextSmall>
      <TextSmall>Esimerkki: energiakokeilut.fi</TextSmall>
    </View>
  ),
  yhteiskayttoautoja: (
    <View>
      <H2>Yhteiskäyttöautot</H2>
      <TextSmall>
        Sähkölään hankitaan 140 yhteiskäyttöistä sähköautoa. Näiden
        avulla 1400 kotitaloutta siirtyy yhteiskäyttöisen sähköauton käyttäjiksi ja luopuu ainakin yhdestä
        kotitaloutensa omasta autosta.
      </TextSmall>
      <H3>Päästövähennys</H3>
      <TextSmall0>
        Päästövähennykset sähköautoon siirtymisestä sekä ajokilometrien vähenemisestä ovat yhteensä 1,8 t CO2 ja 1400 kotitalouden osalta
        yhteensä noin 2,6 kt CO2, eli noin 2% Sähkölän päästöistä.
      </TextSmall0>
      <H3>Investointikustannus</H3>
      <TextSmall0>
        Yhteiskäyttöautoyritys hankkii 140 sähköautoa, kappalehintaan 45.000€.
        Kokonaisinvestoinniksi muodostuu 6,3 M€.
      </TextSmall0>
      <H3>Kustannussäästöt</H3>
      <TextSmall0>
        Toimenpiteestä ei oleteta tulevan kustannussäästöjä käyttäjille, koska
        yhteiskäyttöautopalvelut ovat suurin piirtein saman hintaisia kuin
        omalla autolla ajaminen. Vähän ajaville ja uuden auton omistajille
        yhteiskäyttöautopalvelut ovat kuitenkin edullisempia. Jos sähköläläinen
        hankkii uuden sähköauton sijasta yhteiskäyttöautosopimuksen,
        on se selvästi edullisempi.
      </TextSmall0>
    </View>
  )
}
